import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

export function Login() {
  const { user, loading, signIn } = useAuth();

  if (loading) {
    return <p>Loading…</p>;
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="login">
      <h1>Healthtest</h1>
      <p>Sign in to view and manage doctor visit notes.</p>
      <button type="button" onClick={() => void signIn()}>
        Sign in with Google
      </button>
    </div>
  );
}
